<!--
 * @Author: Merlin
 * @Date: 2024-04-17 19:56:25
 * @LastEditors: Merlin
 * @LastEditTime: 2024-04-23 18:50:00
 * @Description: 
-->

<template>
    <mark class="points points-play points-1"
        :style="pointStyle"
    >
        {{ sPoint }}
    </mark>
</template>

<script lang="ts">
export default defineComponent({
    name: 'blackjackPoint',
    props: {
        pointArr: {
            type: Array as PropType<number[]>,
            required: true,
            default: ()=>[],
        },
        status: {
            type: String,
            required: true,
        },
    },
    computed: {
        pointStyle() {
            let background = '';
            let border = '';
            if (this.status === 'win') {
                background = '#1b9636';
                border = '3px solid #1bb83d';
            }
            if (this.status === 'lose') {
                border = '3px solid #ED1D49FF';
            }
            if (this.status === 'equal') {
                border = '3px solid #ffb636';
            }
            return {
                border: border,
                background: background,
            };
        },
        sPoint(){
            // ↓ 排除0值 
            const arr01 = this.pointArr.filter(Boolean);
            // ↓ 升序
            arr01.sort((aa, bb) => aa - bb);
            return arr01.join('/');
        },
    },
});
</script>

<style lang="scss" scoped>
mark.points{
    color: inherit; 
    font-size: 10px;
    // width: 36px;
    height: 25%; 
    min-height: 25px;
    max-height: 36px;
}
</style>


